import type { AuthLoginRequestDto } from "@/api/space/dtos/authenticator.dto";
import type { IdentificacaoGrupoLogin } from "../../../tiposAutenticacaoJwt";
import { unmaskCPF } from "@/utils/maskUtils";
import { ehIdentificadorCpf } from "./utils/usuarioLogin.utils";

// --------------------------------- TYPES ---------------------------------
type ConstruirLoginUnificadoRequestOptions = {
	readonly identificacao: IdentificacaoGrupoLogin;
	readonly usuario: string;
	readonly senha: string;
	readonly tokenTurnstile: string;
};

// ------------------------------- FUNCTIONS -------------------------------
export function construirLoginUnificadoRequest({
	identificacao,
	usuario,
	senha,
	tokenTurnstile,
}: Readonly<ConstruirLoginUnificadoRequestOptions>): AuthLoginRequestDto {
	const identificador = usuario.trim();

	const usuarioNormalizado = ehIdentificadorCpf(identificador) ? unmaskCPF(identificador) : identificador;
	const verificacao = { platform: "Flow", token_turnstile: tokenTurnstile };

	const credenciais = { ...verificacao, usuario: usuarioNormalizado, senha };

	if (identificacao.tipo === "codigo") return { ...credenciais, codigo: identificacao.valor };
	return { ...credenciais, slug: identificacao.valor };
}

export function construirInicioLoginSpaceRequest(
	identificacao: IdentificacaoGrupoLogin,
	nomeUsuario: string,
	tokenTurnstile: string,
): AuthLoginRequestDto {
	const credenciais = {
		usuario: "SPACE" as const,
		nome_usuario: nomeUsuario.trim().toUpperCase(),
		platform: "Flow",
		token_turnstile: tokenTurnstile,
	};

	if (identificacao.tipo === "codigo") return { ...credenciais, codigo: identificacao.valor };
	return { ...credenciais, slug: identificacao.valor };
}
